import { UseAccountUsageResponse } from 'api/BillingApi';
import { MetricProject, OrgMetric } from 'modules/domains/billing';
import { createContext, useContext } from 'react';

export type QueryContextState = {
  isError: boolean;
  isFetched: boolean;
  isLoading: boolean;
  lastAvailableDatePST?: string;
  /**
   * Org metrics calculated for current/selected billing period
   */
  orgMetricsByName: Record<string, OrgMetric>;
  projects: Record<string, MetricProject>;
  /**
   * Org metrics calculated from start of billing cycle to end date
   * (lastAvailableDate or end of selected billing period)
   */
  billingCycleMetrics: Record<string, OrgMetric>;
  billingPeriodMetrics: UseAccountUsageResponse['values'];
};

const defaultState = {
  isError: false,
  isFetched: false,
  isLoading: false,
  lastAvailableDatePST: '',
  orgMetricsByName: {},
  projects: {},
  billingCycleMetrics: {},
  billingPeriodMetrics: {},
};

export const QueryContext = createContext<QueryContextState>(defaultState);

export const useQueryContext = () => {
  const context = useContext(QueryContext);

  if (!context) {
    throw new Error('useQueryContext must be used within QueryContextProvider');
  }

  return context;
};
